import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, Table, TableBody, TableItem, TableRow} from 'spectacle';
import {Slide} from '../components/slide';
import {Month} from '../support/import_csv';
import {VictoryPie} from 'victory';
import {formatEuro} from '../../support/format_money';
import {victoryColorScale} from '../support/victory_color_scale';
import {format} from 'date-fns';

interface OwnProps {
    referenceDate: Date;
    months: Month[];
}

export const Costs: FunctionComponent<OwnProps> = ({months, referenceDate}) => {
    const monthsThisYear = months.filter((month) => month.date.getFullYear() === referenceDate.getFullYear());
    const costThisYear = monthsThisYear.reduce(
        (sum, month) => {
            return {
                staff: sum.staff + month.costDetails.staff,
                rent: sum.rent + month.costDetails.rent,
                other: sum.other + month.costDetails.other,
            };
        },
        {
            staff: 0,
            rent: 0,
            other: 0,
        },
    );

    return (
        <Slide>
            <Heading size={1} textAlign="left" textColor="secondary">
                Costs distribution
            </Heading>
            <Heading size={3} textAlign="left" textColor="tertiary">
                {format(referenceDate, 'yyyy')}
            </Heading>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableItem>
                            <VictoryPie
                                height={200}
                                colorScale={victoryColorScale}
                                data={[
                                    {x: 'Staff', y: costThisYear.staff},
                                    {x: 'Rent', y: costThisYear.rent},
                                    {x: 'Other', y: costThisYear.other},
                                ]}
                            />
                        </TableItem>
                        <TableItem>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableItem>Salaries</TableItem>
                                        <TableItem>{formatEuro(costThisYear.staff)}</TableItem>
                                    </TableRow>
                                    <TableRow>
                                        <TableItem>Rent</TableItem>
                                        <TableItem>{formatEuro(costThisYear.rent)}</TableItem>
                                    </TableRow>
                                    <TableRow>
                                        <TableItem>Other</TableItem>
                                        <TableItem>{formatEuro(costThisYear.other)}</TableItem>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableItem>
                    </TableRow>
                </TableBody>
            </Table>
        </Slide>
    );
};
